import React from 'react';
import {Redirect, Link} from 'react-router-dom'
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import {withStyles} from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import NavigateNext from '@material-ui/icons/NavigateNext';
import Utility from "../../Utility";
import ApiFetcher from "../../ApiFetcher";

const styles = theme => ({
    root: {
        textAlign: 'center'
    },
    paper: {
        margin: theme.spacing.unit,
    },
    button: {
        margin: 'auto',
        width: '80%',
    },
    iconButton: {
        textAlign: 'right',
    },
    circularProgress: {
        textAlign: 'center',
        margin: theme.spacing.unit,
    },
    noData: {
        padding: theme.spacing.unit*4,
    }
});

function createBackButton(to, label, search){
    const ButtonLink = props => <Link to={{pathname: to, search: search}} {...props} />;
    return (
        <Button component={ButtonLink} variant="contained" color="primary" fullWidth>{label}</Button>
    )
}

function createIconButton(pathname, search){
    const ButtonLink = props => <Link to={{pathname: pathname, search: search}} {...props} />;
    return (
        <IconButton color="primary" component={ButtonLink}>
            <NavigateNext fontSize="large"/>
        </IconButton>
    )
}

export class SelectBusinessPartner extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            businessPartners: [],
            isResponseWait: true,
        };

        let params = new URLSearchParams(this.props.location.search);
        this.pompSpecId = params.get("pompSpecId");
        this.deliveryStart = params.get("deliveryStart");
        this.deliveryEnd = params.get("deliveryEnd");

        this.handleResponse = this.handleResponse.bind(this);

        if(this.props.onScreen !== undefined){
            this.props.onScreen('協力会社選択画面');
        }
    }

    componentDidMount(){
        if(!this.isIllegalQueryParam()){
            ApiFetcher.postBusinessPartners(this.props.cookies.get('token'), this.pompSpecId, this.deliveryStart, this.deliveryEnd, this.handleResponse);
        }
    }

    handleResponse(responseJson){
        this.setState({isResponseWait: false});
        if(responseJson.message === null || responseJson.message === ""){
            this.setState({businessPartners: responseJson.result.businessPartners});
        }
        else{
            // 想定されるエラーは以下の通り.
            // 画面が成立しないのでトップ画面に戻す.
            // + トークン期限切れ
            // + クエリーパラメータ(pompSpecId,deliveryStart,deliveryEnd)が不正
            alert('不正なリクエストのためトップ画面に戻ります。');
            this.props.history.push('/');
        }
    }

    isIllegalQueryParam(){
        if(this.pompSpecId === '' || this.pompSpecId === null || this.deliveryStart === null || this.deliveryEnd === null || !Utility.isDate(this.deliveryStart) || !Utility.isDate(this.deliveryEnd)){
            return true;
        }
        return false;
    }

    render(){
        // KECアカウントでない場合はアクセス不可のためトップ画面へリダイレクト.
        if(!Utility.isKecRole(this.props.cookies.get('role'))){
            return <Redirect to={{pathname: '/'}}/>;
        }

        // クエリパラメータが指定されていなければトップ画面へリダイレクト.
        if(this.isIllegalQueryParam()){
            return <Redirect to={{pathname: "/"}}/>;
        }

        if(this.state.isResponseWait){
            // API応答待ち表示.
            return (
                <div className={this.props.classes.circularProgress}>
                    <CircularProgress/>
                </div>
            );
        }
        else if(this.state.businessPartners.length === 0){
            return (
                <div className={this.props.classes.root}>
                    <Paper className={this.props.classes.paper}>
                        <div className={this.props.classes.noData}>選択可能な協力会社なし</div>
                    </Paper>
                    <div className={this.props.classes.button}>
                        {createBackButton(this.props.backPath, "配車期間入力画面へ戻る", '?pompSpecId=' + this.pompSpecId)}
                    </div>
                </div>
            )
        }
        else{
            return (
                <div className={this.props.classes.root}>
                    <Paper className={this.props.classes.paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>協力会社名</TableCell>
                                    <TableCell>貸出可能台数</TableCell>
                                    <TableCell/>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.businessPartners.map((row, i) =>{
                                    const search = '?pompSpecId=' + this.pompSpecId + '&deliveryStart=' + this.deliveryStart + '&deliveryEnd=' + this.deliveryEnd + '&businessPartner=' + row.objectId;
                                    return (
                                        <TableRow key={i}>
                                            <TableCell>{row.name}</TableCell>
                                            <TableCell>{row.dispatchableNum}</TableCell>
                                            <TableCell className={this.props.classes.iconButton}>{createIconButton(this.props.nextPath, search)}</TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </Paper>
                    <div className={this.props.classes.button}>
                        {createBackButton(this.props.backPath, "配車期間入力画面へ戻る", '?pompSpecId=' + this.pompSpecId)}
                    </div>
                </div>
            );
        }
    }
}

export default withStyles(styles)(SelectBusinessPartner);
